// The six hardware finishes, as a browsable range of their own.
//
// Nothing here is a new product: the catalogue already stores a finish as the
// "Hardware Colour" option on each item, so a finish page is a view over the
// variations that carry this colour. `name` must match the option value in the
// database exactly — it's the key everything joins on.

export const FINISHES = [
  {
    slug: 'chrome',
    name: 'Chrome',
    heading: 'Chrome Plated',
    hero: '/images/hardware/range-chrome.jpg',
    blurb: 'The classic mirror finish. Chrome suits every tapware brand on the market and is the easiest finish to match years later.',
  },
  {
    slug: 'matte-black',
    name: 'Matte Black',
    heading: 'Matte Black',
    hero: '/images/hardware/range-matte-black.jpg',
    blurb: 'A flat, non-reflective black that anchors a light bathroom and disappears into a dark one. Our most-asked-for finish.',
  },
  {
    slug: 'brushed-nickel',
    name: 'Brushed Nickel',
    heading: 'Brushed Nickel',
    hero: '/images/hardware/range-brushed-nickel.jpg',
    blurb: 'Softly brushed and slightly warm — the forgiving finish. Fingerprints and water spots barely show.',
  },
  {
    slug: 'brushed-gold',
    name: 'Brushed Gold',
    heading: 'Brushed Gold',
    hero: '/images/hardware/range-brushed-gold.jpg',
    blurb: 'A bright, contemporary gold with a brushed grain. Pairs with white stone and warm timber.',
  },
  {
    slug: 'brushed-gunmetal',
    name: 'Brushed Gunmetal',
    heading: 'Brushed Gunmetal',
    hero: '/images/hardware/range-brushed-gunmetal.jpg',
    blurb: 'Deep charcoal with a metallic sheen — softer than black, harder-edged than nickel.',
  },
  {
    slug: 'brushed-brass',
    name: 'Brushed Brass',
    heading: 'Brushed Brass',
    hero: '/images/hardware/range-brushed-brass.jpg',
    blurb: 'A deeper, more antique gold. Bold and minimal, and it warms up a monochrome bathroom.',
  },
]

// Swatch gradients for every finish name the catalogue uses — the six above plus the
// odd one-off on an older product, so a swatch never renders blank.
export const FINISH_SWATCHES = {
  Chrome: 'linear-gradient(135deg,#e8eaee,#b9bec7 60%,#dfe2e7)',
  'Matte Black': 'linear-gradient(135deg,#2b2b2e,#151517)',
  'Brushed Nickel': 'linear-gradient(135deg,#cfcfcb,#a8a8a2 60%,#c4c4bf)',
  'Brushed Gold': 'linear-gradient(135deg,#d9b877,#b8934e 60%,#d0ad6c)',
  'Brushed Brass': 'linear-gradient(135deg,#cbb26a,#a68d47 60%,#c1a75f)',
  'Brushed Gunmetal': 'linear-gradient(135deg,#6f7379,#4a4d52 60%,#63666c)',
  'Silver Anodised': 'linear-gradient(135deg,#dcdee2,#b3b6bc 60%,#d2d4d9)',
  'Matt Black': 'linear-gradient(135deg,#2b2b2e,#151517)',
}

export const FINISH_BY_SLUG = Object.fromEntries(FINISHES.map((f) => [f.slug, f]))
export const FINISH_BY_NAME = Object.fromEntries(FINISHES.map((f) => [f.name, f]))

// The option that holds a finish is "Hardware Colour" today, but older imports used
// "Colour" and "Finish" — match on the word rather than the exact heading.
export const isFinishOption = (opt) => /colour|color|finish/i.test(opt?.name || '')

// Options as stored on a product row (a JSON string) → the finish names it offers.
export function finishesOf(product) {
  let options = []
  try { options = JSON.parse(product.options || '[]') || [] } catch { return [] }
  const opt = options.find(isFinishOption)
  return opt ? opt.values : []
}
